/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTimeISO: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
};

export type JobCaterCommentInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  imageFile?: InputMaybe<Scalars['String']['input']>;
  imageURL?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
  timestamp?: InputMaybe<Scalars['String']['input']>;
  userAvatarFile?: InputMaybe<Scalars['String']['input']>;
  userAvatarURL?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type JobPostCaterObject = {
  __typename?: 'JobPostCaterObject';
  _id: Scalars['ID']['output'];
  comments: Scalars['JSON']['output'];
  company: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  hiringManagerName?: Maybe<Scalars['String']['output']>;
  position: Scalars['String']['output'];
  requirementsComparison: Scalars['JSON']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type JobPostCaterUpdateInput = {
  company: Scalars['String']['input'];
  hiringManagerName?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['String']['input'];
  requirementsComparison: Scalars['JSON']['input'];
};

export type Message = {
  __typename?: 'Message';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  email: Scalars['String']['output'];
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type MessageInput = {
  email: Scalars['String']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addCommentToJobPostCater: JobPostCaterObject;
  createJobPostCater: JobPostCaterObject;
  createMessage: Message;
  deleteCater: Scalars['String']['output'];
  deleteCommentFromJobPostCater: JobPostCaterObject;
  deleteJobPostCater: JobPostCaterObject;
  requestCommentImageUploadUrl: SignedUrlPayload;
  updateCommentFromJobPostCater: JobPostCaterObject;
  updateJobPostCater: JobPostCaterObject;
};


export type MutationAddCommentToJobPostCaterArgs = {
  caterID: Scalars['String']['input'];
  comment: JobCaterCommentInput;
  imageKey?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateJobPostCaterArgs = {
  input: NewJobPostCaterInput;
};


export type MutationCreateMessageArgs = {
  input: MessageInput;
};


export type MutationDeleteCaterArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCommentFromJobPostCaterArgs = {
  caterID: Scalars['String']['input'];
  commentID: Scalars['String']['input'];
};


export type MutationDeleteJobPostCaterArgs = {
  id: Scalars['String']['input'];
};


export type MutationRequestCommentImageUploadUrlArgs = {
  filename: Scalars['String']['input'];
  filetype: Scalars['String']['input'];
};


export type MutationUpdateCommentFromJobPostCaterArgs = {
  caterID: Scalars['String']['input'];
  comment: JobCaterCommentInput;
  commentID: Scalars['String']['input'];
};


export type MutationUpdateJobPostCaterArgs = {
  id: Scalars['String']['input'];
  input: JobPostCaterUpdateInput;
};

export type NewJobPostCaterInput = {
  company: Scalars['String']['input'];
  position: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  jobPostCater?: Maybe<JobPostCaterObject>;
  jobPostCaters: Array<JobPostCaterObject>;
  message?: Maybe<Message>;
  messages: Array<Message>;
};


export type QueryJobPostCaterArgs = {
  id: Scalars['String']['input'];
};


export type QueryMessageArgs = {
  id: Scalars['String']['input'];
};

export type SignedUrlPayload = {
  __typename?: 'SignedUrlPayload';
  key?: Maybe<Scalars['String']['output']>;
  uploadUrl: Scalars['String']['output'];
};

export type SendMessageMutationVariables = Exact<{
  input: MessageInput;
}>;


export type SendMessageMutation = { __typename?: 'Mutation', createMessage: { __typename?: 'Message', _id: string } };


export const SendMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"sendMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MessageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode<SendMessageMutation, SendMessageMutationVariables>;